/**
 * Created by dannyr on 13/12/2016.
 */

import React from "react";

import { chosenSites } from "app/common/services/chosenSites";

export interface WaPositionTooltipContentProps {
    data?: Array<{
        Key: string;
        Value: number;
    }>;
}

export class WaPositionTooltipContent extends React.Component<WaPositionTooltipContentProps> {
    static defaultProps = { data: [] };

    private chosenSites: any;

    constructor(props: WaPositionTooltipContentProps) {
        super(props);
        this.chosenSites = chosenSites;
    }

    render() {
        const items = [];
        // @ts-ignore FIXME: strict migration - this.props.data is optional but defaultProps guarantees [] at runtime
        for (let i = 0; i < this.props.data.length; i++) {
            // @ts-ignore FIXME: strict migration - this.props.data is optional but defaultProps guarantees [] at runtime
            const item = this.props.data[i];
            const rank = item.Value;
            const site = item.Key;
            const hasRanks = rank !== -1;
            const color = this.chosenSites.getSiteColor(site);
            items.push(
                <div
                    key={site}
                    style={{ padding: "5px 0" }}
                >
                    <span
                        className="legend-item-circle"
                        style={{ background: color, marginRight: 5, verticalAlign: "middle" }}
                    />
                    <span
                        style={{
                            display: "inline-block",
                            width: "112px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                            marginRight: "10px",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {site}
                    </span>
                    <span style={{ float: "right" }}>{hasRanks ? rank : "-"}</span>
                </div>,
            );
        }
        return <div>{items}</div>;
    }
}
